import { Component, OnInit, input } from '@angular/core';

import { ApButtonSkeletonComponent, ApParagraphSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApTokenSelectorSkeletonComponent
 */
@Component({
    selector: 'ap-token-selector-skeleton',
    standalone: true,
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApButtonSkeletonComponent, ApParagraphSkeletonComponent]
})
export class ApTokenSelectorSkeletonComponent implements OnInit {
    /**
     * Required - Does sign have a control on which the token is remembered?
     */
    public readonly hasRememberControl = input.required<boolean>();

    /**
     * Required - Amount of available token types
     */
    public readonly tokenTypesLength = input.required<number>();

    public tokenTypes: void[];

    public ngOnInit(): void {
        this.tokenTypes = new Array(this.tokenTypesLength());
    }
}
